import { render } from "./IconBuild.vue?vue&type=template&id=300c0dc2"
import script from "./IconBuild.vue?vue&type=script&lang=js"
export * from "./IconBuild.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__